<template>
  <div class="body">
    <div style="padding-top:130px">
      <el-row>
        <div style="
          font-family: 'Roboto Serif',serif;
          font-weight: 700;
          font-size: 64px;
          line-height: 75px;
          color:#3E6161;">How to get started?</div>
      </el-row>
    </div>

    <div class="mt-5" style="padding: 60px 0 80px 0;">
      <el-row type="flex" :gutter="60" style="height: 600px">
        <el-col :span="12">
          <div v-if="isActive === '1'">
            <video autoplay muted loop src="@/assets/f1.mp4" id="f1"></video>
          </div>

          <div v-else-if="isActive === '2'">
            <video autoplay muted loop src="@/assets/f2.mp4" id="f2"></video>
          </div>

          <div v-else>
            <video autoplay muted loop src="@/assets/f3.mp4" id="f3"></video>
          </div>
        </el-col>
        <el-col :span="12" class="my-20">
          <div class="flex option" style="padding-left:2px">
            <div class="index" :class="isActive === '1' ? 'active-bg-color' : ''" @click="isActive = '1'" >
              01
            </div>

            <div class="description">
              <div class="description-title">
                Schedule A Demo
              </div>
              <div class="description-detail">
                During your demo, you will learn the ins and outs of the ZHR from our EHR Manager.
              </div>
            </div>
          </div>

          <div class="flex option">
            <div class="index" :class="isActive === '2' ? 'active-bg-color' : ''" @click="isActive = '2'">
              02
            </div>

            <div class="description">
              <div class="description-title">
                Create an Account
              </div>
              <div class="description-detail">
                When you decide the ZHR is right for you, you will set up your account.
              </div>
            </div>
          </div>

          <div class="flex option">
            <div class="index" :class="isActive === '3' ? 'active-bg-color' : ''" @click="isActive = '3'">
              03
            </div>

            <div class="description">
              <div class="description-title">
                Build your EHR
              </div>
              <div class="description-detail">
                Now that your account is set up, we will transfer your data into the ZHR
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isActive: "1"
      };
    }
  };
</script>

<style scoped>
.body{
  padding: 0 100px 0px 100px;
}

.index {
  color: #3E6161;
  width: 60px;
  height: 60px;
  font-size: 39px;
  background-color: #F0EAE1;
  border-radius: 50px 50px 50px 50px;
  padding-left: 7px;
  padding-right: 7px;
  font-family: 'Roboto Serif';
}

.description {
  margin-left: 20px;
  width: 535px;
  height: 159px;
}

.description-title {
  font-size: 26px;
  color: #3E6161;
}

.description-detail {
  font-size: 18px;
  color: #000000;
}

.option:hover .index{
  background-color: #3E6161;
  color: #F0EAE1;
  cursor: pointer;
}

.active-bg-color {
  background-color: #3E6161;
  color: #F0EAE1;
}

</style>